import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { AUTHOR_ADVANCE_INVOICE_GENERATE } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';

@Component({
  selector: 'app-author-advances-invoice-generated',
  templateUrl: './author-advances-invoice-generated.component.html',
  styleUrls: ['./author-advances-invoice-generated.component.css'],
})
export class AuthorAdvancesInvoiceGeneratedComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectedStatus: string = '';
  dateModified: string = '';
  listStatus: any = [];
  listDateModified: any = [];
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;
  currency: { [key: string]: string } = {
    British_Pounds: 'British Pounds',
    US_Dollar: 'US Dollar',
    Euro: 'Euro',
  };

  ngOnInit(): void {
    this.loadProducts(this.createPostData());
    this.listStatus = [
      'New',
      'Invoice Generated',
      'Invoice Approved',
      'Invoice Rejected',
    ];
    this.listDateModified = [
      'current_week',
      'last_week',
      'current_month',
      'last_month',
      'current_year',
      'last_year',
      'last_3_months',
      'last_6_months',
      'last_3_years',
    ];
  }

  loadProducts(
    postData: any = [],
    url: string = AUTHOR_ADVANCE_INVOICE_GENERATE
  ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      status: this.selectedStatus,
      date_modified: this.dateModified,
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      AUTHOR_ADVANCE_INVOICE_GENERATE,
      {
        is_download: 1,
        status: this.selectedStatus,
        date_modified: this.dateModified,
        page: this.currentPage,
      },
      '',
      'author_advance_invoice_generate'
    );
  }

  updateSelectedType(event: any) {
    //console.log(event);

    if (event.name == 'status') {
      this.selectedStatus = event.selectedOption;
    }
    if (event.name == 'dateModified') {
      this.dateModified = event.selectedOption;
    }
    console.log(this.selectedStatus, this.dateModified);
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      status: this.selectedStatus,
      date_modified: this.dateModified,
      page: this.currentPage,
    });

    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    (this.selectedStatus = ''),
      (this.dateModified = ''),
      this.clearAllDropDowns();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }

  getCurrency(value: string) {
    return this.currency[value] || null;
  }
}
